import { render, staticRenderFns } from "./DsfExamEntrance.vue?vue&type=template&id=4a72947d&"
import script from "./DsfExamEntrance.vue?vue&type=script&lang=js&"
export * from "./DsfExamEntrance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a72947d')) {
      api.createRecord('4a72947d', component.options)
    } else {
      api.reload('4a72947d', component.options)
    }
    module.hot.accept("./DsfExamEntrance.vue?vue&type=template&id=4a72947d&", function () {
      api.rerender('4a72947d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/DsfExamEntrance.vue"
export default component.exports